import {  useEffect, useState } from "react";
import AuthContext from "./lib/auth-context";
import { Routes, Route } from "react-router-dom";

import ThemeContext from "./lib/theme-context";

import LogIn from "./pages/log-in-screen";
import DashBoard from "./pages/dashboard";
import Loading from "./components/loading/loading.component";
import SharedForecast from "./pages/shared-forecast";
import SharedJournal from "./pages/shared-journal";
import SharedReflection from "./pages/shared-reflection";
import { ProtectedRoute } from "./lib/authWrapper";
import { mongoDBRequest } from "./services/api/dbRequest";
import { useNavigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import throwMessage from "./utils/throwMessage";

function isEmpty(obj) {
  for (const prop in obj) {
    if (Object.hasOwn(obj, prop)) {
      return false;
    }
  }

  return true;
}

const App = () => {
  const [theme, setTheme] = useState("dark");
  const [auth, setAuth] = useState(false);
  const navigate = useNavigate();
  const [forecasts, setForecasts] = useState([]);
  const [forecastsBacktesting, setForecastsBacktesting] = useState([]);
  const [trades, setTrades] = useState([]);
  const [allTrades, setAllTrades] = useState([]);
  const [reflections, setReflections] = useState([]);
  const [journals, setJournals] = useState([]);
  const [journalsBacktesting, setJournalsBacktesting] = useState([]);
  const [backtests, setBacktests] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [tab, setTab] = useState(undefined);
  const [backtestingMode, setBacktestingMode] = useState(false);
  const [viewMode, setViewMode] = useState("all-view");
  const [equityTypeMode, setEquityTypeMode] = useState("Personal Capital");

  const [allYearsOfTrades, setAllYearsOfTrades] = useState([]);
  


  const [realisedBalanceIC, setRealisedBalanceIC] = useState(
    localStorage.getItem("balanceIC")
  );
  const [realisedBalancePC, setRealisedBalancePC] = useState(
    localStorage.getItem("balancePC")
  );

  

  const [inProgressMode, setInProgressMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [defaultValue, setDefaultValue] = useState();
  const [status, setStatus] = useState(false);

  const handleLogIn = async (email, password) => {
    setLoading(true);
    return mongoDBRequest("sign-in", "POST", {
      email: email,
      password: password,
    })
      .then(async (data) => {
        if (data.TC_TOKEN_AUTH) {
          setAuth(true);
          localStorage.setItem("screen", 0);
          localStorage.setItem("theme", "dark");
          localStorage.setItem("calendar-view-mode", "All");
          localStorage.setItem("view-mode", "simple-view");
          localStorage.setItem("equity-mode", "Personal Capital");
          localStorage.setItem("TC_TOKEN_AUTH", data.TC_TOKEN_AUTH);
          localStorage.setItem("user", JSON.stringify(data.user));
          
          // Initialize skipPreviousYears setting from user data
          localStorage.setItem("skipPreviousYears", data.user.skipPreviousYears ? "true" : "false");
          
          navigate("/");
          throwMessage("success", "Authenticated");
        } else {
          setAuth(false);
          if (data === "User with that email does not exist") {
            throwMessage("warning", data);
          } else if (data === "Email and password do not match") {
            throwMessage("warning", data);
          } else {
            throwMessage(
              "warning",
              "Oops Something went wrong please check the console"
            );
          }
        }
      })
      .catch((err) => {
        if (!isEmpty(err)) throwMessage("error", JSON.stringify(err));
      });
  };
  const handleBacktestingMode = (d) => {
    setEquityTypeMode("Personal Capital");
    localStorage.setItem("equity-mode", "Personal Capital");
    
    // Set account selector to All Personal Accounts when entering backtesting mode
    if (d) {
      // Save the current account ID before switching
      const currentAccountId = localStorage.getItem("selected-account-id");
      if (currentAccountId) {
        localStorage.setItem("pre-backtest-account-id", currentAccountId);
      }
      
      localStorage.setItem("selected-account-id", "All Personal");
      // Dispatch event to notify AccountSelector components
      window.dispatchEvent(new CustomEvent("account-changed", { 
        detail: { accountId: "All Personal" } 
      }));
    } else {
      // Restore the previous account ID when leaving backtesting mode
      const previousAccountId = localStorage.getItem("pre-backtest-account-id");
      if (previousAccountId) {
        localStorage.setItem("selected-account-id", previousAccountId);
        // Dispatch event to notify AccountSelector components
        window.dispatchEvent(new CustomEvent("account-changed", { 
          detail: { accountId: previousAccountId } 
        }));
        localStorage.removeItem("pre-backtest-account-id");
      }
    }
    
    setBacktestingMode(d);
  };
  const authCheck = async () => {
    const TC_TOKEN_AUTH = localStorage.getItem("TC_TOKEN_AUTH");
    if (TC_TOKEN_AUTH) {
      return await mongoDBRequest("verify", "POST", {
        TC_TOKEN_AUTH: TC_TOKEN_AUTH,
      })
        .then(async (data) => {
          if (data === "valid TC_TOKEN_AUTH") {
            setAuth(true);
            return true;
          } else {
            localStorage.removeItem("TC_TOKEN_AUTH");
            localStorage.removeItem("user");
            setAuth(false);
            return false;
          }
        })
        .catch((err) => {
          localStorage.removeItem("TC_TOKEN_AUTH");
          localStorage.removeItem("user");
          setAuth(false);
          if (!isEmpty(err)) throwMessage("error", JSON.stringify(err));
          return false;
        });
    } else {
      localStorage.removeItem("TC_TOKEN_AUTH");
      localStorage.removeItem("user");
      setAuth(false);
      return false;
    }
  };

  useEffect(() => {
    const changeStatus = () => {
      if (!navigator.onLine) {
        setStatus(false);
        localStorage.setItem("TC-status", false);
      } else if (navigator.onLine) {
        setStatus(true);
        localStorage.setItem("TC-status", true);
      }
    };

    setStatus(navigator.onLine);
    localStorage.setItem("TC-status", navigator.onLine);

    window.addEventListener("online", changeStatus);
    window.addEventListener("offline", changeStatus);

    return () => {
      window.removeEventListener("online", changeStatus);
      window.removeEventListener("offline", changeStatus);
    };
  }, []);

  useEffect(() => {
    // Load tab state from localStorage on app startup
    const savedScreen = localStorage.getItem("screen");
    if (savedScreen !== null) {
      setTab(Number(savedScreen));
    } else {
      setTab(0); // Default to Calendar if no screen is saved
    }
  }, []);


  return (
    <>
      <Toaster 
        position="top-right" 
        toastOptions={{
          style: {
            zIndex: 99999,
          },
        }}
        containerStyle={{
          zIndex: 99999,
        }}
      />
      <ThemeContext.Provider value={[theme, setTheme]}>
        <AuthContext.Provider
          value={{   
            allYearsOfTrades: allYearsOfTrades,
            setAllYearsOfTrades: setAllYearsOfTrades,
            realisedBalanceIC: realisedBalanceIC,
            setRealisedBalanceIC: setRealisedBalanceIC,
            realisedBalancePC: realisedBalancePC,
            setRealisedBalancePC: setRealisedBalancePC,
         
            setBacktestingMode: setBacktestingMode,
            setTheme: setTheme,
            allTrades: allTrades,
            setAllTrades: setAllTrades,
            trades: trades,
            reflections: reflections,
            forecasts: forecasts,
            forecastsBacktesting: forecastsBacktesting,
            journals: journals,
            journalsBacktesting: journalsBacktesting,
            backtests: backtests,
            holidays: holidays,
            setTrades: setTrades,
            setBacktests: setBacktests,
            setReflections: setReflections,
            setForecasts: setForecasts,
            setForecastsBacktesting: setForecastsBacktesting,
            setJournals: setJournals,
            setJournalsBacktesting: setJournalsBacktesting,
            setHolidays: setHolidays,
            tab: tab,
            setTab: setTab,
            throwMessage: throwMessage,
            backtestingMode: backtestingMode,
            handleBacktestingMode: handleBacktestingMode,
            viewMode: viewMode,
            setViewMode: setViewMode,
            inProgressMode: inProgressMode,
            setInProgressMode: setInProgressMode,
            defaultValue: defaultValue,
            setDefaultValue: setDefaultValue,
            setLoading: setLoading,
            status: status,
            equityTypeMode: equityTypeMode,
            setEquityTypeMode: setEquityTypeMode,
          }}
        >
          <Routes>
            <Route
              path="/log-in"
              element={<LogIn handleLogIn={handleLogIn} />}
            />
            <Route
              path="/"
              element={
                <ProtectedRoute authCheck={authCheck}>
                  {!loading && auth ? (
                    <DashBoard />
                  ) : loading && auth ? (
                    <Loading />
                  ) : (
                    <Loading />
                  )}
                </ProtectedRoute>
              }
            />

            <Route
              path="/forecast/:pair/:direction/:dateSlug"
              element={<SharedForecast />}
            />

            <Route
              path="/journal/:pair/:direction/:dateSlug"
              element={<SharedJournal />}
            />

            <Route
              path="/reflection/:typeOfReview/:dateSlug"
              element={<SharedReflection />}
            />

            <Route
              path="*"
              element={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100vw",
                    height: "100vh",
                  }}
                >
                  <p style={{ color: "#FCFCFF" }}>Nothing Lives Here</p>
                </div>
              }
            />
          </Routes>
        </AuthContext.Provider>
      </ThemeContext.Provider>
    </>
  );
};

export default App;
